import { createContext } from 'react';
import { ChartOfAccountsService } from '../services/ChartOfAccountsService';
import { FiscalSponsorService } from '../services/FiscalSponsorService';
import { Form990Service } from '../services/Form990Service';

interface ServiceContextType {
  chartOfAccountsService: ChartOfAccountsService;
  fiscalSponsorService: FiscalSponsorService;
  form990Service: Form990Service;
}

export const ServiceContext = createContext<ServiceContextType | null>(null); 